module.exports = {"511325001":"南台街道","511325002":"晋城街道","511325101":"太平镇","511325102":"大全镇","511325103":"仙林镇","511325104":"古楼镇","511325105":"义兴镇","511325106":"关文镇","511325107":"凤鸣镇","511325108":"青狮镇","511325109":"槐树镇","511325110":"鸣龙镇","511325111":"双凤镇","511325112":"高院镇","511325113":"仁和镇","511325114":"多扶镇","511325115":"莲池镇","511325116":"常林镇","511325203":"占山乡","511325226":"祥龙乡","511325227":"车龙乡","511325229":"东太乡","511325232":"罐垭乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511325.json
// module id = 2478
// module chunks = 0